import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LCLShipmentModel } from '@data-layer/models/lcl';

@Component({
  selector: 'lcl-shipment-details',
  templateUrl: './lcl-shipment-details.component.html',
  styleUrls: ['./lcl-shipment-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclShipmentDetailsComponent {
  @Input() public shipment: LCLShipmentModel;

  constructor() {}
}
